import { clsx } from 'clsx';
import { Footer } from 'turnip/Footer/Footer';

export function PageWithFooter({
  gapBeforeFooter = true,
  children,
}: {
  gapBeforeFooter?: boolean;
  children: React.ReactNode;
}) {
  return (
    <div
      className={clsx(
        'flex min-h-dvh flex-col justify-between',
        gapBeforeFooter && 'gap-16'
      )}
    >
      <div className="flex flex-1">
        <div className="max-w-full flex-1">{children}</div>
      </div>

      <Footer />
    </div>
  );
}
